module.exports = __webpack_public_path__ + "files/b493d09994e9a386678a75b777ba092b.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/smileys_emotion-4.png
// module id = 498
// module chunks = 76